export const faqs = [
  {
    q: 'What kind of book is this?',
    a: `The Quantum Awakening is hard science fiction — but written for readers who are not necessarily sci-fi readers. The science is rigorous and internally consistent: quantum computing, terraforming, consciousness upload, fusion energy, interstellar propulsion. But the book's primary focus is human: the families, the daily lives, the costs, and the emotional weight of five centuries of civilizational change. If you loved The Martian for its science but wished it was bigger in scope and slower in heart, this is that book.`,
  },
  {
    q: 'Is it a series or standalone?',
    a: `It is a complete standalone chronicle. The story begins in 2025 and ends in 2514, with an intentionally open final act — the signal from deep space, the Odyssey outbound, the next chapter unwritten. There is no sequel planned. The book ends where it ends because that is where the known story ends.`,
  },
  {
    q: 'Is it long?',
    a: `Yes. This is an epic. Eleven chapters across five centuries and eight worlds. It is not a fast read — it is a deep one. Readers who finish it typically describe the experience as close to reading a complete history of the future.`,
  },
  {
    q: 'What is "the Quantum Awakening" — is it a character or an event?',
    a: `It is an event — the civilizational inflection point triggered by Dr. Elena Vasquez's creation of the first stable quantum processor in 2025. It refers to the moment humanity crossed the threshold between the world it had built and the world it became capable of building. The title refers to this event, not to a character, a place, or a specific chapter.`,
  },
  {
    q: 'Does the book take sides on questions like climate change or AI?',
    a: `It does not moralize. It presents consequences. The Earth chapter — described by the author as written "in shame" — chronicles climate collapse, civilizational failure, and unnecessary suffering without flinching. The AI chapters present consciousness upload and quantum intelligence as transformative without being utopian. The book trusts readers to draw their own conclusions. It offers no villains. Only choices.`,
  },
  {
    q: 'Is it available in Romanian?',
    a: `Yes. The Romanian edition — Trezirea Cuantică: O Cronică a Ascensiunii Umane — is available on ciomirtan.com.`,
    link: { label: 'Visit ciomirtan.com (RO)', href: 'https://ciomirtan.com/book/trezirea-cuantica-o-cronica-a-ascensiunii-umane/' },
  },
  {
    q: 'Where can I get it?',
    a: null,
    editions: [
      { label: 'Kindle Edition', price: '$6.99', href: 'https://www.amazon.com/dp/B0GXDZXVNV', primary: true },
      { label: 'Paperback', price: '$17.99', href: 'https://www.amazon.com/dp/B0GXKS9ZSV', primary: false },
      { label: 'Hardcover', price: '$26.99', href: 'https://www.amazon.com/dp/B0GXK8VRZJ', primary: false },
    ],
  },
];